import { render } from "./cp_record_school.vue?vue&type=template&id=86ca4e28&scoped=true"
import script from "./cp_record_school.vue?vue&type=script&lang=js"
export * from "./cp_record_school.vue?vue&type=script&lang=js"

import "./cp_record_school.vue?vue&type=style&index=0&id=86ca4e28&scoped=scoped&lang=css"

import exportComponent from "E:\\Work\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86ca4e28"]])

export default __exports__